import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import ReactHlsPlayer from "./ReactHlsPlayer";

interface VideoPlayerOptions
  extends React.VideoHTMLAttributes<HTMLVideoElement> {
  src?: string;
  onVideoElementChange: (el: HTMLVideoElement | null) => void;
}

const VideoPlayer = forwardRef<HTMLVideoElement, VideoPlayerOptions>(
  ({ src, onVideoElementChange, ...videoOptions }, ref) => {
    const playerRef = useRef<HTMLVideoElement>(null);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useImperativeHandle(ref, () => playerRef.current as HTMLVideoElement, [
      src,
    ]);
    useEffect(() => {
      console.log("# src changed", src);
    }, [src]);

    useEffect(() => {
      if (onVideoElementChange) {
        onVideoElementChange(playerRef.current);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [playerRef.current, onVideoElementChange, src]);

    return isHlsPlaylist(src) ? (
      <ReactHlsPlayer
        playerRef={playerRef}
        //   getHLSRef={(hlsJSObject: Hls) => {
        //     console.log(hlsJSObject);
        //   }}
        src={src}
        {...videoOptions}
      />
    ) : (
      <video ref={playerRef} src={src} {...videoOptions} />
    );
  }
);

export default VideoPlayer;

export const isHlsPlaylist = (url?: string) => {
  return url && url.includes("m3u");
};
